import React from 'react';
import { Link } from 'react-router-dom';

export default function FooterContact() {
    return (
        <>
            <section class="pad-80 CallAction-Section">
                <div class="container">
                    <div class="CallActionContent">
                        <span class="text-white cta-title">Ready to get back to business?</span>
                        <p class="text-white">Ready to secure your digital assets and get back to business with robust cybersecurity solutions?</p>
                        <div class="pt-3">
                            <Link to="/contact-us"><button>Contact Us Now</button></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
